import {useData} from "vike-react/useData";
import {ApiLivestreamData, ApiStreamerFaq} from "#/src/definitions/ApiDefinitions";
import {Sort} from "#/src/utils/sort-utils";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import DOMPurify from "isomorphic-dompurify";

export function StreamerFaqs() {
  const {data: livestreamData} = useData() as DataWrapped<ApiLivestreamData>;
  if(livestreamData.streamer.faq.length === 0) {
    return <></>
  }

  function render() {
    return <section className="faq-channel" id="faq">
      <div className="container-xxl">
        <div className="row">
          <div className="col-xl-12">
            <h2 className="basic-headline mb-4">Pytania i odpowiedzi</h2>
          </div>
          <div className="col-xl-12">
            <div className="accordion accordion-flush" id="accordionFlushExample">{renderFaqs()}</div>
          </div>
        </div>
      </div>
    </section>
  }

  function renderFaqs() {
    return Sort.byDisplayPriority(livestreamData.streamer.faq).map((faq: ApiStreamerFaq) => {
      return <div key={faq.id} className="accordion-item">
        <h2 className="accordion-header">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#flush-${faq.id}`}
            aria-expanded="false"
            aria-controls={`flush-${faq.id}`}
          >{faq.title}</button>
        </h2>
        <div
          id={`flush-${faq.id}`}
          className="accordion-collapse collapse"
          data-bs-parent="#accordionFlushExample"
        >
          <div className="accordion-body" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(faq.description)}}/>
        </div>
      </div>
    });
  }

  return render();
}